const SFBFF_LOG_EVENTS_HOST =
  process.env.REACT_APP_SFBFF_LOG_EVENTS_HOST || "https://sfbff.networksolutions.com";

const levels = ["error", "warn", "info", "verbose", "debug", "trace"];

export const SF_LOG_LEVEL = {
  TRACE: 1,
  VERBOSE: 2,
  INFO: 3,
  DEBUG: 4,
  WARN: 5,
  ERROR: 6,
};

async function logEvent(logData) {
  const logDataModel = {
    level: "",
    applicationId: "",
    eventType: "",
    brand: "",
    message: "",
    errorCode: "",
    errorDetails: "",
    siteId: "",
    userId: "",
    environment: "",
    customAttributes: "",
    host: "",
  };

  const filteredLogData = Object.keys(logDataModel).reduce((acc, key) => {
    if (logData[key]) {
      acc[key] = logData[key];
    }

    return acc;
  }, {});

  const url = `${SFBFF_LOG_EVENTS_HOST}/logEvents/sendEvent`;

  if (levels.includes(filteredLogData.level) && filteredLogData.applicationId) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(filteredLogData),
      });

      if (response.status >= 300) {
        throw new Error("Failed to log event");
      }
    } catch (error) {
      console.error("Error logging event:", error);
    }
  } else {
    console.error(`Invalid log level ${filteredLogData.level} or missing applicationId`);
  }
}

class SFLogger {
  constructor(build, appId) {
    this.build = build;
    this.applicationId = appId;
  }

  handleLogRequest() {
    return "SEND_LOG";
  }

  info(logData, rngTrace) {
    this.log(logData, SF_LOG_LEVEL.INFO, rngTrace);
  }

  warn(logData, rngTrace) {
    this.log(logData, SF_LOG_LEVEL.WARN, rngTrace);
  }

  error(logData, rngTrace) {
    this.log(logData, SF_LOG_LEVEL.ERROR, rngTrace);
  }

  verbose(logData, rngTrace) {
    this.log(logData, SF_LOG_LEVEL.VERBOSE, rngTrace);
  }

  debug(logData, rngTrace) {
    this.log(logData, SF_LOG_LEVEL.DEBUG, rngTrace);
  }

  trace(logData, rngTrace) {
    this.log(logData, SF_LOG_LEVEL.TRACE, rngTrace);
  }

  log(logData, level, rngTrace) {
    try {
      const customAttributes = logData.customAttributes || {};
      if (rngTrace) customAttributes.rngTrace = rngTrace;

      switch (this.handleLogRequest(level)) {
        case "SEND_LOG":
          logEvent({
            ...logData,
            customAttributes,
            environment: this.build,
            level: this.getLevelName(level).toLowerCase(),
            applicationId: this.applicationId,
          });
          break;
        case "CONSOLE_LOG":
        case "OTHER":
        case "DO_NOTHING":
        default:
          break;
      }
    } catch (error) {
      console.error("something went wrong while logging");
      console.error(error);
    }
  }

  getLevelName(level) {
    switch (level) {
      case SF_LOG_LEVEL.DEBUG:
        return "DEBUG";
      case SF_LOG_LEVEL.ERROR:
        return "ERROR";
      case SF_LOG_LEVEL.INFO:
        return "INFO";
      case SF_LOG_LEVEL.TRACE:
        return "TRACE";
      case SF_LOG_LEVEL.VERBOSE:
        return "VERBOSE";
      case SF_LOG_LEVEL.WARN:
        return "WARN";
      default:
        return "INFO";
    }
  }
}

export const sfLogger = new SFLogger(
  process.env.NODE_ENV === "production" ? "prod" : "qa",
  "WEB.COM_HOMEPAGE"
);
